//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { DateGroupProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { DateInputProps } from "models/propTypes/wintFormPropsTypes";
import { IconDefinitionConstants, InvoiceConstants } from "utils/constants";
import { NestedKeyOf } from "models/utilTypes/nestedKeyType";
import { InvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import {
  HorizontalFormField,
  DateInput,
  GroupSection,
  FormFieldLayout,
  NumberInputWithSuggestions,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

function DateGroup({ connect, values }: DateGroupProps) {
  const hideDeliveryDate = useSelector((store: AppState) => store.auth.selectedCompany.hideInvoiceDeliveryDate);
  /* Due date is changed if invoice date is changed, that change happens in the WizardQuickSelection-component.
   */
  const dueDateConnector = connect("otherSettings.dueDate");

  const onDueDateChange = (dueDate?: Date) => {
    dueDateConnector.setValue(dueDate, true);

    const invoiceDate = values.otherSettings?.invoiceDate;

    if (
      dueDate === undefined ||
      isNaN(Date.parse(invoiceDate.toString())) ||
      invoiceDate === undefined ||
      isNaN(Date.parse(dueDate.toString()))
    )
      return;
    const diffDays = DateHelper.getDiffDays(invoiceDate, dueDate);
    if (diffDays === values.otherSettings?.paymentTerms) return;

    const paymentTermsFieldName: NestedKeyOf<InvoiceFormTypes.Create> = "otherSettings.paymentTerms";
    connect(paymentTermsFieldName).setValue(diffDays, true);
    connect(paymentTermsFieldName).setTouched();
  };

  return (
    <GroupSection
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Dates)}
      icon={IconDefinitionConstants.WCalendar}
    >
      <HorizontalFormField<DateInputProps>
        Component={DateInput}
        {...connect("otherSettings.invoiceDate")}
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.InvoiceDate)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.InvoiceDateDescription)}
      />
      {!values.quotationSerialNumber && !hideDeliveryDate && (
        <HorizontalFormField<DateInputProps>
          Component={DateInput}
          {...connect("otherSettings.deliveryDate")}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.DeliveryDate)}
          descriptionText={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Invoice.DeliveryDateDescription
          )}
        />
      )}
      <FormFieldLayout
        {...dueDateConnector}
        direction="horizontal"
        label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentTerms)}
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.Invoice.PaymentTermsDescription
        )}
      >
        <Grid item container spacing={1}>
          <Grid item xs={6}>
            <NumberInputWithSuggestions
              {...connect("otherSettings.paymentTerms")}
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PaymentTerms)}
              allowNegative
              suffix={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Days).toLowerCase()}
              suggestions={InvoiceConstants.PaymentTerms}
            />
          </Grid>
          <Grid item xs={6}>
            <DateInput
              {...dueDateConnector}
              setValue={onDueDateChange}
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.DueDate)}
            />
          </Grid>
        </Grid>
      </FormFieldLayout>
    </GroupSection>
  );
}

export default DateGroup;
